import { render, staticRenderFns } from "./shippingAddress.vue?vue&type=template&id=c020e5ca&scoped=true"
import script from "./shippingAddress.vue?vue&type=script&lang=js"
export * from "./shippingAddress.vue?vue&type=script&lang=js"
import style0 from "./shippingAddress.vue?vue&type=style&index=0&id=c020e5ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c020e5ca",
  null
  
)

export default component.exports